import {
  IMeta_ProjectConfig_App_Config_Support,
} from '@kaidam/fc-shared/src/types/schema/project_config'

import {
  IMeta_ProjectConfig_App_Config_Knowledgebase,
} from '@kaidam/fc-shared/src/types/schema/knowledgebase'

import {
  IRecord_User,
} from '@kaidam/fc-shared/src/types/schema/user'

import {
  IRecord_Project,
} from '@kaidam/fc-shared/src/types/schema/project'

import {
  IData_UserSummary,
} from '@kaidam/fc-shared/src/types/schema/user_summary'

import {
  hasRoleAccessToType,
} from '@kaidam/fc-shared/src/utils/role'

import {
  getSummaryNamespaceRoles,
  hasRole,
} from '@kaidam/fc-shared/src/utils/role'

import {
  hasFeature,
} from '@kaidam/fc-shared/src/utils/features'
import {
  MenuItem,
  AppMenuFactory,
} from './types/app'

import authActions from './store/modules/auth'

export const GUEST_MENU = [{
  title: 'Login',
  link: 'login',
  icon: 'login',
}]

const APP_MENUS: Record<string, AppMenuFactory> = {
  knowledgebase: (config, roles) => {
    if (!config) return []
    const opsHub: MenuItem[] = [{
      title: 'Operations Hub',
      icon: 'opsmanual',
      link: 'operationshub',
    }]

    return opsHub
  },
  support: (config, roles) => {
    if (!config) return []
    const supportConfig = config as IMeta_ProjectConfig_App_Config_Support
    const supportTypes = supportConfig.types
    return supportTypes
      .filter(type => {
        return roles.find(role => hasRoleAccessToType(role, type.name)) ? true : false
      })
      .map<MenuItem>(type => {
        return {
          title: type.title,
          icon: type.icon,
          link: 'support',
          params: {
            type: type.name,
          }
        }
      })
  },
  reporting: () => {
    return [{
      title: 'Reporting',
      icon: 'reporting',
      link: 'reporting',
    }]
  },
  coconut_ppc_payments: () => {
    return [{
      title: 'Payments',
      icon: 'payments',
      link: 'coconut_ppc_payments',
    }]
  },
  crm: () => {
    return [{
      title: 'CRM',
      icon: 'crm',
      link: 'crm',
    }]
  },
  marketing: () => {
    return [{
      title: 'Marketing',
      icon: 'marketing',
      link: 'marketing',
    }]
  },
  astonish: () => {
    return [{
      title: 'Email',
      icon: 'email',
      link: 'astonish',
    }]
  },
  rbac: (config, roles, summary) => {
    const hasNetwork = hasFeature(summary, 'show_network_icon', true)
    const hasEventViewer = summary.roles['rbac:event_viewer']
    const network = {
      title: 'Network',
      icon: 'network',
      link: 'network',
    }
    const frachiseFeed = {
      title: 'Audit Trail',
      icon: 'audit',
      link: 'audit', 
    }
    return [
      hasNetwork ? network : null,
      hasEventViewer ? frachiseFeed : null,
    ].filter(i => i)
  },
  booking: () => {
    return [{
      title: 'Booking',
      icon: 'booking',
      link: 'booking',
    }]
  },
  storage: () => {
    return [{
      title: 'Filestore',
      icon: 'filestore',
      link: 'filestore',
    }]
  },
  nopress: () => {
    return [{
      title: 'Website',
      icon: 'website',
      link: 'nopress',
    }]
  }
}

// we use a basic determination right now of if a user has the roles
// required to show a menu item
// it's whether they have "any" role within the namespace of the app
export const getAppMenu = (user: IRecord_User | null, summary: IData_UserSummary | null, project: IRecord_Project | null): MenuItem[] => {
  if (!user || !summary || !project) return []
  const appConfigs = project.meta ? project.meta.apps || [] : []
  return appConfigs.reduce<MenuItem[]>((all, appConfig) => {
    const roles = getSummaryNamespaceRoles(summary, appConfig.namespace)
      .filter(role => hasRole(summary, role.name))
    if (roles.length <= 0) return all
    const appMenuFactory = APP_MENUS[appConfig.namespace]
    if (!appMenuFactory) return all
    return all.concat(appMenuFactory(appConfig.config, roles, summary))
  }, [])
}

export const getDashboardMenu = (user: IRecord_User | null, summary: IData_UserSummary | null, project: IRecord_Project | null): MenuItem[] => {
  if (!user || !summary || !project) return []
  return getAppMenu(user, summary, project)
    .concat([
      {
        title: 'Settings',
        icon: 'settings',
        link: 'settings'
      },
    ])
}

export const getMainMenu = (user: IRecord_User | null, summary: IData_UserSummary | null, project: IRecord_Project | null): MenuItem[] => {
  if (!user) return GUEST_MENU

  const LOGOUT: MenuItem = {
    title: 'Logout',
    icon: 'logout',
    handler: (dispatch, getState) => {
      dispatch(authActions.logout())
    },
  }

  if (!project) {
    return [LOGOUT]
  }

  const appMenu = getAppMenu(user, summary, project)

  const beforeAppMenu: MenuItem[] = [
    {
      title: 'Dashboard',
      icon: 'dashboard',
      link: 'dashboard'
    },
    {
      title: '-',
    },
  ]

  const afterAppMenu: MenuItem[] = [
    {
      title: '-',
    },
    {
      title: 'Settings',
      icon: 'settings',
      link: 'settings'
    },
    LOGOUT,
  ]

  return beforeAppMenu
    .concat(appMenu)
    .concat(afterAppMenu)
}

